import React from 'react'
import styled from 'styled-components'
import { AiOutlineSave } from 'react-icons/ai'
import { FaRegEdit } from 'react-icons/fa'

import { Button } from '../../../buttons'

import { FONTS } from '../../../../constants'

export const ActionBar = (props) => {
  const {
    isEdit,
    canEdit,
    projectByID,
    setIsEdit,
    isPresale,
    clickEdit,
    clickCancel,
  } = props

  const showEdit = !isPresale && canEdit

  const total_change_requests_cost = projectByID ? projectByID.$total_change_requests_cost : '-'
  const total_change_requests_price = projectByID ? projectByID.$total_change_requests_price : '-'

  return (
    <Root>
      <Wrapper>
        <TextWrapper>
          <Title>All Cost:</Title>&nbsp;
          <Text>{`฿${total_change_requests_cost}`}</Text>
        </TextWrapper>
        <TextWrapper>
          <Title>All Price:</Title>&nbsp;
          <Text>{`฿${total_change_requests_price}`}</Text>
        </TextWrapper>
      </Wrapper>
      <ButtonGroup>
        { showEdit && !isEdit && (
          <Button
            width='70px'
            height='26px'
            theme='#28a745'
            onClick={ () => setIsEdit(true) }
            icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
          >
            Edit
          </Button>
        )}
        { isEdit && (
          <ActionWrapper>
            <Button
              width='70px'
              height='26px'
              theme='#28a745'
              onClick={ clickEdit }
              icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            >
              Save
            </Button>
            <Button
              width='70px'
              height='26px'
              theme='#6c757d'
              onClick={ clickCancel }
            >
              Cancel
            </Button>
          </ActionWrapper>
        )}
      </ButtonGroup>
    </Root>
  )
}

const Root = styled.div`
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background: #FFFFFF;
`

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    flex: 1;
`

const ActionWrapper = styled(Wrapper)`
    div:nth-child(1) {
      margin-right: 12px;
    }
`

const ButtonGroup = styled(Wrapper)`
`

const TextWrapper = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`

const Title = styled.span`
    font-family: ${FONTS.GOTHAM_BOLD};
    font-size: ${FONTS.NORMAL_SIZE};
    color: #414141;
`

const Text = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.NORMAL_SIZE};
    color: #414141;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-change-request/action-bar.js